export default "/images/vendor/flag-icon-css/flags/1x1/au.svg?5b98a120aeec3f5a1aeb9c0a8c011cf8";